import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setCohort } from 'Workspace/Cohorts/store/actions';
import { FormattedMessage } from 'react-intl';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const workspaceCohort = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_COHORT,
    cohortId: action.cohortId,
  });
  if (workspaceCohort.type === constants.RTM_WORKSPACE_COHORT_OK) {
    const cohort = workspaceCohort.response.cohort;
    yield put(setCohort(cohort));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspaceCohortFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_COHORT, catchErrors, sendRequest, connection);
}
